import { trackAnalyticsEvent } from '@/analytics'
import {
  ACTOR_TYPE,
  CHECKIN_DUE,
  CHECKIN_TYPE,
  DATA_SOURCE,
  EVENT_ACTION,
  EVENT_CATEGORY
} from '@/constants/analytics'

const getActorType = (userId, goal, kr) => {
  if (kr.ownerId === userId) {
    return ACTOR_TYPE.KR_OWNER
  } else if (goal.ownerId === userId) {
    return ACTOR_TYPE.GOAL_OWNER
  }
  return ACTOR_TYPE.NON_OWNER
}

/**
 * This adds checkin event details to analytics
 * @param userId
 * @param goal
 * @param kr
 * @param source
 * @param isLinkedToGoogleSheet
 * @param isCheckinOverdue
 * @param name
 */
const trackCheckinEvent = (
  userId,
  goal,
  kr,
  { source, isLinkedToGoogleSheet, isCheckinOverdue },
  name
) => {
  trackAnalyticsEvent(
    EVENT_CATEGORY.ACTIVITY,
    EVENT_ACTION.CHECK_IN,
    {
      CTA: source,
      dataSource: isLinkedToGoogleSheet ? DATA_SOURCE.GOOGLE_SHEET : DATA_SOURCE.MANUAL,
      checkinType: CHECKIN_TYPE.SINGLE,
      checkinActor: getActorType(userId, goal, kr),
      checkinDue: isCheckinOverdue ? CHECKIN_DUE.CHECK_IN_OVERDUE : CHECKIN_DUE.CHECK_IN_DUE
    },
    name
  )
}

export default trackCheckinEvent
